import { ErrorState } from "./ErrorState";
import { ProblemNote } from "./ProblemNote";

/** The parts of a read that say how it went: TanStack Query's result has them all. */
export interface ReadOutcome {
  isError: boolean;
  error: unknown;
  data: unknown;
  refetch: () => unknown;
}

/**
 * What a failed read says, by what it leaves on screen. With nothing read it stands in for the
 * pane, with Try again; when a read again fails, what was read stays and this is the line beside
 * it, so words being typed into it stay mounted. Nothing while the read stands.
 */
export function ReadProblem({
  query,
  what,
  className,
}: {
  query: ReadOutcome;
  /** What was being read, as the attorney knows it: "the framework". */
  what: string;
  className?: string;
}) {
  if (!query.isError) return null;
  const readAgain = () => void query.refetch();
  return query.data === undefined ? (
    <ErrorState
      error={query.error}
      what={what}
      onRetry={readAgain}
      className={className}
    />
  ) : (
    <ProblemNote
      error={query.error}
      what={what}
      act="load"
      onRetry={readAgain}
      className={className}
    />
  );
}
